var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',[_c('vue-qrcode',{staticClass:"d-block mx-auto my-4",attrs:{"value":_vm.value,"options":_vm.options}}),_c('div',{staticClass:"cash-text text-center"},[_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }